import { useParams } from "react-router-dom";
import { MatchTeamForm } from "./components/MatchTeamForm";
import { matchTeamService } from "@/frontend/services";
import type { MatchTeamResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdateMatchTeamPage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useGetId<MatchTeamResponseDTO>({
    fetchFn: matchTeamService.getById,
    redirectUrl: "/match-teams",
    errorMessage: "Error al cargar el equipo",
    id,
  });

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando..." />
        </div>
      </div>
    );
  }

  if (!data) return null;

  const initialValues = {
    disciplineId: data.disciplineId,
    subCategoryIds: data.subCategoryIds ?? [],
    name: data.name,
    description: data.description ?? "",
    imageUrl: data.imageUrl ?? "",
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Actualizar Equipo</h2>
        <p className="text-gray-600 mt-1">
          Modifica la información del equipo
        </p>
      </div>
      <MatchTeamForm matchTeamId={id} initialValues={initialValues} />
    </div>
  );
}
